@if (dataLayerTypeStore.pointLayers().length === 0) {
  <app-alert header="Keine Standorte vorhanden" [canToggle]="false">
    Bevor Sie Standorte importieren können, müssen Sie zuerst
    <a
      [routerLink]="[
        '/data-backend',
        {
          outlets: {
            overlay: ['neu', { outlets: { panel: ['poi', 'neu'] } }],
          },
        },
      ]"
      >Standorte</a
    >
    anlegen.
  </app-alert>
} @else {
  @if (!poiToImport.length) {
    <header>
      <app-header
        icon="fas fa-location-arrow"
        text="Auswahl treffen"></app-header>
      <div class="p-3 flex gap-3 p-card surface-ground align-items-center">
        <ng-container
          *ngIf="dataLayerTypeStore.getByType('Point') as layerTypes">
          <app-type-dropdown
            [mode]="'Point'"
            [globalSelector]="true"
            [(selection)]="selectedType"></app-type-dropdown>
        </ng-container>
        <div class="">
          <app-layer-dropdown
            [displayNewYearOption]="true"
            [selectedTypeId]="selectedType?._id || null"
            [disabled]="!selectedType"
            [(selection)]="selectedLayer"
            [globalSelector]="true"></app-layer-dropdown>
        </div>
        <div class="ml-auto flex gap-3">
          <app-download-template type="poi"></app-download-template>
        </div>
      </div>
    </header>
  } @else {
    <app-header
      icon="fas fa-cloud-upload"
      text="Import überprüfen"
      sub="Prüfen Sie Ihre Standorte."></app-header>

    <div class="grid mb-3">
      <div class="col-6" *ngFor="let severity of validationPreviewSeverities">
        <app-import-preview-box
          [key]="severity"
          [numberOfEntities]="getItemsBy(severity).length"
          (itemsToShow)="setItemsToShow(severity)"></app-import-preview-box>
      </div>
    </div>

    <!--<div class="flex gap-3 mt-3">
      <p-button
        *ngIf="poiToImport.length"
        [rounded]="true"
        [outlined]="true"
        icon="fas fa-times"
        label="abbrechen"
        severity="secondary"
        (click)="cancel()">
      </p-button>
    </div>
    <p-divider></p-divider>-->
  }
  @if (selectedType) {
    <div class="grid">
      <div class="col-5">
        @if (!poiToImport.length) {
          <app-header
            icon="fas fa-cloud-upload"
            text="Import"
            sub="Laden Sie Ihre Standorte hoch."></app-header>
          <div class="flex gap-3">
            <p-fileUpload
              mode="basic"
              chooseLabel="Datei hochladen"
              chooseIcon="pi pi-upload"
              name="uploadFile"
              [url]="geoDataService.getPoiImportUrl()"
              [auto]="true"
              accept=".xlsx"
              maxFileSize="1000000"
              (onUpload)="onUpload($event)" />
          </div>

          <a
            class="mt-1 text-xs"
            [routerLink]="[{ outlets: { panel: 'geo-daten' } }]"
            [relativeTo]="activatedRoute.parent"
            ><i class="fas fa-circle-info"></i> Ihre Standorte liegen als
            Geodatei vor? Nutzen Sie den Geodaten-Import!</a
          >

          <app-alert severity="info" [canToggle]="false">
            <h4 class="flex gap-2 align-items-center">
              <i class="fas fa-circle-info"></i> Standorte importieren
            </h4>
            <p>Die Datei muss einem bestimmten Schema entsprechen.</p>
            <p>
              Laden Sie die passende <b>Vorlage</b> herunter, um das richtige
              Format zu verwenden.
            </p>
          </app-alert>
        }
        <app-header icon="fas fa-map-location-dot" text="Vorschau"></app-header>
        @if (poiPreview && poiPreview.features?.length) {
          <div class="h-29rem">
            <app-basic-map
              [dataLayerType]="selectedType"
              [geoJsonData]="poiPreview"></app-basic-map>
          </div>
        } @else {
          <app-alert
            styleClass="py-1 px-3"
            [canToggle]="false"
            severity="secondary">
            <h4 class="flex gap-2">
              <i class="fas fa-ban"></i> Keine Vorschau verfügbar
            </h4>
          </app-alert>
        }
      </div>
      <div class="col-7">
        @if (!poiToImport.length && this.geoStore.geoJsonFromSelection()) {
          <app-header
            icon="fas fa-cloud-download"
            text="Export"
            sub="Laden Sie Ihre Standorte als Excel-Datei herunter."></app-header>

          <p-button
            [disabled]="!selectedType || !selectedLayer"
            (click)="exportSelected()"
            [rounded]="true"
            icon="fas fa-file-excel"
            label="exportieren"></p-button>
          <p-divider />
        }

        @if (geoStore.initialized()) {
          <app-feature-form
            #importFeatureForm
            type="Point"
            (triggerConvert)="convertAddresses()"
            (submitted)="cancel()"
            (cancelled)="cancel()"
            [selectedLayer]="selectedLayer"
            [activeImport]="poiToImport.length > 0"
            [convertAvailable]="poiToImport.length > 0 && hasWarnings"
            [inputFeatures]="
              poiPreview && poiPreview.features.length
                ? poiPreview.features
                : undefined
            "></app-feature-form>
        }
      </div>
    </div>
  } @else {
    <div
      appAlertStyle="info"
      class="px-3 py-2 flex gap-2 align-items-center flex-wrap">
      <i class="fas fa-info-circle"></i> Wählen Sie zuerst einen Standort aus.
    </div>
  }
}
<p-sidebar
  (onHide)="closeOverview()"
  position="right"
  [modal]="false"
  [styleClass]="'w-6'"
  [visible]="itemsToShowInOverview.length > 0">
  <ng-template pTemplate="header">
    <app-header icon="fas fa-circle-info" text="Übersicht"></app-header
  ></ng-template>
  <app-poi-import-list
    *ngIf="itemsToShowInOverview.length > 0"
    [icon]="icon"
    [items]="itemsToShowInOverview"></app-poi-import-list>
</p-sidebar>

<app-mask
  [visible]="itemsToShowInOverview.length > 0"
  (click)="closeOverview()"></app-mask>
